import { useState, useRef, useEffect } from 'react';
import { usePage } from '../../content/PageContext';
import '../../pages.css';

export default function NavManager() {
  const { page, loaded, saveNav } = usePage();
  const [items, setItems] = useState([]);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const inited = useRef(false);

  useEffect(() => {
    if (loaded && !inited.current) {
      setItems(page.nav || []);
      inited.current = true;
    }
  }, [loaded, page.nav]);

  const setItem = (i, patch) => setItems((prev) => prev.map((x, j) => (j === i ? { ...x, ...patch } : x)));
  const move = (i, dir) => setItems((prev) => {
    const ni = i + dir;
    if (ni < 0 || ni >= prev.length) return prev;
    const next = [...prev];
    [next[i], next[ni]] = [next[ni], next[i]];
    return next;
  });
  const add = () => setItems((prev) => [...prev, { id: 'new-' + Date.now().toString(36), label: '新页面', visible: true }]);
  const remove = (i) => setItems((prev) => prev.filter((_, j) => j !== i));

  async function onSave() {
    setSaving(true); setMsg('');
    try {
      await saveNav(items);
      setMsg('已保存');
    } catch (e) {
      setMsg('保存失败：' + e.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="admin-section">
      <div className="toolbar">
        <button className="btn" onClick={add}>+ 新增导航项</button>
        <button className="btn primary" onClick={onSave} disabled={saving}>{saving ? '保存中…' : '保存排序'}</button>
        {msg && <span className={msg.startsWith('保存失败') ? 'error' : 'success'}>{msg}</span>}
      </div>
      <p className="muted">调整顶部导览的顺序与显示；「锚点 id」对应页面区块的锚点 id（如 about、career）。</p>
      <table className="admin-table">
        <thead><tr><th>顺序</th><th>显示文字</th><th>锚点 id</th><th>可见</th><th></th></tr></thead>
        <tbody>
          {items.map((n, i) => (
            <tr key={n.id}>
              <td>
                <button className="mini-btn" onClick={() => move(i, -1)}>↑</button>
                <button className="mini-btn" onClick={() => move(i, 1)}>↓</button>
              </td>
              <td><input value={n.label} onChange={(e) => setItem(i, { label: e.target.value })} /></td>
              <td><input value={n.id} onChange={(e) => setItem(i, { id: e.target.value })} /></td>
              <td><input type="checkbox" checked={n.visible !== false} onChange={(e) => setItem(i, { visible: e.target.checked })} /></td>
              <td><button className="btn secondary" onClick={() => remove(i)}>删除</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
